$(document).ready(function () {
    console.log('Subscription JS loaded - FIXED PRICE UPDATE VERSION');
    
    // ---------------------------
    // GLOBAL VARIABLES
    // ---------------------------
    let currentSellingPlanId = '';
    let isInitialLoad = true;
    let currentVariantId = '';
    let currentQuantity = 2; // Default to 2 jars
    
    // Store references to DOM elements
    const variantSelects = document.querySelector('variant-selects');
    const productForm = document.querySelector('product-form');
    const topJarButtons = document.querySelectorAll(".jar-selector-btn");
    const jarRadios = document.querySelectorAll('input[name="quantity_radio_group"]');
    
    // ---------------------------
    // FUNCTION TO CLEAN UP INLINE STYLES
    // ---------------------------
    function cleanupInlineStyles() {
        const freeProductWrapper = $('.free-product-wrapper');
        
        // Remove any inline display styles that might conflict with class
        if (freeProductWrapper.attr('style')) {
            console.log('Cleaning up inline styles from wrapper');
            freeProductWrapper.css('display', ''); // Remove inline display style
        }
    }
    
    // ---------------------------
    // SIZE BUTTON AND FREE PRODUCT WRAPPER - COMPLETE FIX
    // ---------------------------
    function updateSizeButtonAndWrapper() {
        console.log('=== UPDATE SIZE BUTTON AND WRAPPER ===');
        
        const selectedRadio = $('input[name="quantity_radio_group"]:checked');
        const sizeButton = $('.size-button');
        const freeProductWrapper = $('.free-product-wrapper');
        
        if (!selectedRadio.length || !sizeButton.length || !freeProductWrapper.length) {
            console.log('Missing elements');
            return;
        }
        
        const variantId = selectedRadio.data('variant-id') || selectedRadio.attr('data-variant-id');
        console.log('Selected variant ID:', variantId);
        
        // Find the jar button to check availability
        const jarButton = $(`.jar-selector-btn[data-variant-id="${variantId}"]`);
        
        if (jarButton.length) {
            const variantAvailable = jarButton.data('variant-available') || jarButton.attr('data-variant-available');
            console.log('Variant available:', variantAvailable);
            
            // Log current wrapper state
            console.log('Wrapper current state:', {
                hasHiddenClass: freeProductWrapper.hasClass('hidden'),
                isVisible: freeProductWrapper.is(':visible'),
                inlineStyle: freeProductWrapper.attr('style'),
                classes: freeProductWrapper.attr('class')
            });
            
            if (variantAvailable === 'false' || variantAvailable === false) {
                console.log('UNAVAILABLE VARIANT - FORCE HIDING WRAPPER');
                
                // Disable the size button
                sizeButton.prop('disabled', true);
                sizeButton.css({
                    'opacity': '0.5',
                    'cursor': 'not-allowed'
                });
                
                // FORCE HIDE THE WRAPPER using class only
                console.log('FORCE ADDING HIDDEN CLASS');
                freeProductWrapper.addClass('hidden');
                
                // Remove any inline display style that might conflict
                freeProductWrapper.css('display', '');
                
            } else {
                console.log('AVAILABLE VARIANT - ENABLING BUTTON ONLY');
                
                // Enable the size button
                sizeButton.prop('disabled', false);
                sizeButton.css({
                    'opacity': '1',
                    'cursor': 'pointer'
                });
                
                // Remove any inline display style from previous unavailable state
                freeProductWrapper.css('display', '');
                
                // IMPORTANT: Do NOT change wrapper visibility here
                // Let the button clicks control showing/hiding
                console.log('Wrapper visibility unchanged - controlled by button clicks');
                console.log('Current wrapper state:', {
                    hasHiddenClass: freeProductWrapper.hasClass('hidden'),
                    isVisible: freeProductWrapper.is(':visible'),
                    inlineStyle: freeProductWrapper.attr('style')
                });
            }
        }
    }
    
    // ---------------------------
    // PRICE CALCULATION HELPERS
    // ---------------------------
    function parsePrice(priceString) {
        if (!priceString) return 0;
        // Remove currency symbol and commas, keep only numbers and decimal
        const cleanString = priceString.replace(/[^0-9.]/g, '');
        return parseFloat(cleanString) || 0;
    }
    
    function formatPrice(amount) {
        return '$' + amount.toFixed(2);
    }
    
    function calculateTotalPrice(pricePerUnit, quantity) {
        const priceNum = parsePrice(pricePerUnit);
        return formatPrice(priceNum * quantity);
    }
    
    // ---------------------------
    // CORE SELLING PLAN FUNCTIONS
    // ---------------------------
    function initializeSellingPlanOnPageLoad() {
        console.log('=== INITIALIZING SELLING PLAN ON PAGE LOAD ===');
        
        // Get the default selling plan from data attribute
        const defaultSellingPlanInput = document.querySelector('.selling-plan-input');
        if (!defaultSellingPlanInput) {
            console.error('Selling plan input not found!');
            return;
        }
        
        const defaultSellingPlanId = defaultSellingPlanInput.dataset.defaultSellingPlan || '';
        console.log('Default selling plan from data attribute:', defaultSellingPlanId);
        
        // Check if subscription is selected on page load
        const isSubscribe = $('#subscribe-save').is(':checked');
        const selectedRadio = $('input[name="quantity_radio_group"]:checked');
        
        console.log('Initial state:', {
            isSubscribe,
            selectedQty: selectedRadio.val(),
            selectedRadioExists: selectedRadio.length > 0
        });
        
        if (isSubscribe && selectedRadio.length) {
            // Use the radio button's selling plan ID
            const sellingPlanId = selectedRadio.data('selling-id') || selectedRadio.attr('data-selling-id') || defaultSellingPlanId;
            currentSellingPlanId = sellingPlanId;
            console.log('Setting initial selling plan ID:', sellingPlanId);
            
            // Update ALL selling plan related inputs
            updateAllSellingPlanInputs(sellingPlanId, true);
        } else {
            // Clear selling plan for one-time
            currentSellingPlanId = '';
            updateAllSellingPlanInputs('', false);
            console.log('Initialized for one-time purchase');
        }
        
        isInitialLoad = false;
    }
    
    function updateAllSellingPlanInputs(sellingPlanId, isSubscribe) {
        const val = isSubscribe ? sellingPlanId : '';
        
        // Target all possible naming conventions used by apps and themes
        $('input[name="selling_plan"], .selling-plan-input').val(val);
        $('input[name="selling_plan_id"], .selling-plan-id-input').val(val);
        $('input[name="subscription"], .subscription-input').val(isSubscribe ? 'true' : 'false');
        $('input[name="properties[Purchase type]"], .purchase-type-input').val(
            isSubscribe ? "Subscribe & Save" : "One Time"
        );
        
        console.log('DOM Inputs Updated:', isSubscribe ? `Plan ${val}` : 'One-Time');
    }
    
    function updateSellingPlan() {
        const isSubscribe = $('#subscribe-save').is(':checked');
        const selectedRadio = $('input[name="quantity_radio_group"]:checked');
        
        console.log('updateSellingPlan called:', {
            isSubscribe,
            selectedQty: selectedRadio.val(),
            selectedRadioExists: selectedRadio.length > 0
        });
        
        if (isSubscribe && selectedRadio.length) {
            const sellingPlanId = selectedRadio.data('selling-id') || selectedRadio.attr('data-selling-id') || '';
            
            if (sellingPlanId && sellingPlanId !== currentSellingPlanId) {
                currentSellingPlanId = sellingPlanId;
                updateAllSellingPlanInputs(sellingPlanId, true);
                console.log('Updated selling plan to:', sellingPlanId);
            }
        } else {
            // Clear for one-time purchase
            currentSellingPlanId = '';
            updateAllSellingPlanInputs('', false);
            console.log('Cleared selling plan for one-time purchase');
        }
    }
    
    // ---------------------------
    // AJAX INTERCEPTOR (CRITICAL FIX)
    // ---------------------------
    const originalFetch = window.fetch;
    window.fetch = function() {
        // Check if this is a cart drawer upgrade operation
        if (window.cartDrawerUpgradeActive) {
            console.log('Cart drawer upgrade active - skipping subscription interceptor');
            return originalFetch.apply(this, arguments);
        }

        // Free-gift (Period Underwear) add — never inject a subscription selling plan
        // into the free line item; it must be added as a plain one-time item.
        if (window.__chewyGiftAdd) {
            return originalFetch.apply(this, arguments);
        }
        
        if (arguments[0] && typeof arguments[0] === 'string' && arguments[0].includes('/cart/add')) {
            const isSubscribe = document.querySelector('#subscribe-save')?.checked;
            const selectedRadio = document.querySelector('input[name="quantity_radio_group"]:checked');
            
            if (isSubscribe && selectedRadio) {
                const spId = selectedRadio.getAttribute('data-selling-id');
                console.log('AJAX Interceptor active: Injecting Selling Plan:', spId);
                
                // Handle FormData (standard forms)
                if (arguments[1] && arguments[1].body instanceof FormData) {
                    arguments[1].body.set('selling_plan', spId);
                } 
                // Handle JSON (common in modern AJAX carts)
                else if (arguments[1] && typeof arguments[1].body === 'string') {
                    try {
                        let bodyObj = JSON.parse(arguments[1].body);
                        if (bodyObj.items) {
                            bodyObj.items[0].selling_plan = parseInt(spId);
                        } else {
                            bodyObj.selling_plan = parseInt(spId);
                        }
                        arguments[1].body = JSON.stringify(bodyObj);
                    } catch(e) {
                        console.error('AJAX Interceptor: Could not parse body', e);
                    }
                }
            }
        }
        return originalFetch.apply(this, arguments);
    };
    
    // ---------------------------
    // ENHANCED FORM SUBMISSION HANDLER
    // ---------------------------
    function setupFormSubmissionHandler() {
        console.log('Setting up form submission handler');
        
        // Intercept ALL add to cart forms
        $(document).on('submit', 'form[action*="/cart/add"]', function(e) {
            console.log('=== FORM SUBMISSION INTERCEPTED ===');
            
            // Get current state
            const isSubscribe = $('#subscribe-save').is(':checked');
            const selectedRadio = $('input[name="quantity_radio_group"]:checked');
            const sellingPlanValue = $('input[name="selling_plan"]').val();
            
            console.log('Form state before submission:', {
                isSubscribe,
                selectedQty: selectedRadio.val(),
                sellingPlanValue,
                sellingPlanInputExists: $('input[name="selling_plan"]').length
            });
            
            if (isSubscribe) {
                // Double-check selling plan is set
                const sellingPlanId = selectedRadio.data('selling-id') || selectedRadio.attr('data-selling-id') || '';
                
                if (!sellingPlanValue && sellingPlanId) {
                    console.warn('Selling plan missing! Setting it now:', sellingPlanId);
                    updateAllSellingPlanInputs(sellingPlanId, true);
                }
                
                // Ensure quantity is set
                const qty = selectedRadio.val() || 2;
                updateQuantity(qty);
                
                // Log the final form data for debugging
                const formData = new FormData(this);
                console.log('=== FINAL FORM DATA ===');
                for (let [key, value] of formData.entries()) {
                    console.log(key + ': ' + value);
                }
            } else {
                // Ensure selling plan is cleared for one-time
                if (sellingPlanValue) {
                    console.warn('Clearing selling plan for one-time purchase');
                    updateAllSellingPlanInputs('', false);
                }
            }
            
            // Let the form submit normally
            return true;
        });
    }
    
    // ---------------------------
    // FREE UNDERWEAR TOGGLE FUNCTION
    // ---------------------------
function isFreeProductEnabled() {
    return $('product-info').attr('data-show-free-prod') === 'true';
}

function clearUnderwearProperty() {
    $('input[name="properties[Period Underwear Size]"], .underwear-size-input')
        .val('')
        .prop('disabled', true);
}

function enableUnderwearProperty() {
    $('input[name="properties[Period Underwear Size]"], .underwear-size-input')
        .prop('disabled', false);
}

function toggleFreeUnderwear() {
    console.log('toggleFreeUnderwear called');

    const selectedQty = parseInt($('input[name="quantity_radio_group"]:checked').val(), 10);
    const isSubscribe = $('#subscribe-save').is(':checked');
    const $underwearSection = $(".free-underwear");

    if (!isFreeProductEnabled()) {
        $underwearSection.addClass("hidden");
        clearUnderwearProperty();
        console.log('Free product disabled from section setting');
        return;
    }

    if (!isSubscribe && selectedQty === 1) {
        $underwearSection.addClass("hidden");
        clearUnderwearProperty();
        console.log('Hidden: one-time + 1 qty');
    } else {
        $underwearSection.removeClass("hidden");
        enableUnderwearProperty();

        const selectedSize = $('input[name="underwear_size"]:checked').val();

        if (selectedSize) {
            $('input[name="properties[Period Underwear Size]"], .underwear-size-input').val(selectedSize);
        }

        console.log('Shown:', isSubscribe ? 'subscribe' : 'one-time + ' + selectedQty + ' qty');
    }
}
    
    // ---------------------------
    // BOTTLE TEXT UPDATE FUNCTION
    // ---------------------------
    function updateBottleText() {
        const isSubscribe = $('#subscribe-save').is(':checked');
        const selectedQty = $('input[name="quantity_radio_group"]:checked').val();
        
        $('.bottle-text').addClass('hidden');
        
        if (isSubscribe) {
            const index = parseInt(selectedQty) - 1;
            $('.bottle-text').eq(index).removeClass('hidden');
        }
    }
    
    function updateQuantity(qty) {
        console.log('Updating quantity to:', qty);
        currentQuantity = qty;
        
        $('input[name="properties[Custom qty]"], .custom-qty-input').val(qty);
        $('input[name="properties[Custom qty second]"]').val(qty);
        $('input[name="quantity"], .product-quantity-input').val(qty);
    }

    function updateShippingText() {
        const $shippingText = $('.shipping-txt');
        if (!$shippingText.length) return;

        const selectedQty = parseInt(
            $('input[name="quantity_radio_group"]:checked').val(),
            10
        ) || 1;

        let days = 30;

        if (selectedQty === 2) days = 60;
        // 3 and 6 pouches both ship on the 3-monthly plan (the 6-pack is
        // the 3 Jar variant at qty 6), so anything >= 3 renews every 90 days.
        if (selectedQty >= 3) days = 90;

        $shippingText.text(`Ships Every ${days} Days.`);
    }
    
    // ---------------------------
    // MAIN PRICE UPDATE FUNCTION (FIXED)
    // ---------------------------
    function updateAllPrices() {
        console.log('updateAllPrices called');
        
        // Get current selections
        const isSubscribe = $('#subscribe-save').is(':checked');
        const selectedQtyRadio = $('input[name="quantity_radio_group"]:checked');
        const selectedQty = parseInt(selectedQtyRadio.val()) || 2;
        
        console.log('Current selection:', {
            isSubscribe,
            selectedQty,
            radioElement: selectedQtyRadio[0]
        });
        
        if (!selectedQtyRadio.length) {
            console.error('No quantity radio selected');
            return;
        }
        
        // Get price data from selected radio
        const subSinglePrice = selectedQtyRadio.data('sub-single') || 
                              selectedQtyRadio.data('sub_single') || 
                              selectedQtyRadio.attr('data-sub-single') || 
                              selectedQtyRadio.attr('data-sub_single') || 
                              '0';
        const subTotalPrice = selectedQtyRadio.data('sub-total') || 
                             selectedQtyRadio.data('sub_total') || 
                             selectedQtyRadio.attr('data-sub-total') || 
                             selectedQtyRadio.attr('data-sub_total') || 
                             '0';
        const oneTimePrice = selectedQtyRadio.data('one-time') || 
                            selectedQtyRadio.attr('data-one-time') || 
                            '0';
        const comparePrice = selectedQtyRadio.data('compare') || 
                            selectedQtyRadio.attr('data-compare') || 
                            '0';
        const subComparePrice = selectedQtyRadio.data('compare-sub') || 
                               selectedQtyRadio.data('compare_sub') || 
                               selectedQtyRadio.attr('data-compare-sub') || 
                               selectedQtyRadio.attr('data-compare_sub') || 
                               selectedQtyRadio.data('sub_total_compare') || 
                               '0';
        
        console.log('Price data from radio:', {
            subSinglePrice,
            subTotalPrice,
            oneTimePrice,
            comparePrice,
            subComparePrice
        });
        
        // Calculate totals
        const oneTimeTotal = calculateTotalPrice(oneTimePrice, selectedQty);
        const compareTotal = calculateTotalPrice(comparePrice, selectedQty);
        
        // For subscription, use the total price if available, otherwise calculate it
        let subTotal = subTotalPrice;
        if (!subTotal || subTotal === '0') {
            subTotal = calculateTotalPrice(subSinglePrice, selectedQty);
        }
        
        let subCompareTotal = subComparePrice;
        if (!subCompareTotal || subCompareTotal === '0') {
            // If no subscription compare price, use the regular compare price
            subCompareTotal = compareTotal;
        }
        
        console.log('Calculated totals:', {
            oneTimeTotal,
            compareTotal,
            subTotal,
            subCompareTotal
        });
        
        // Toggle bottle price visibility
        if (isSubscribe) {
            $('.sub-per-bottle-price').removeClass('hidden');
            $('.per-bottle-price').addClass('hidden');
            console.log('Showing subscription prices');
        } else {
            $('.per-bottle-price').removeClass('hidden');
            $('.sub-per-bottle-price').addClass('hidden');
            console.log('Showing one-time prices');
        }
        
        // ALWAYS UPDATE BOTH SECTIONS (One Time AND Subscribe)
        // Update ONE-TIME section
        if ($('.one-main-price-wrapper').length) {
            $('.one-main-price-wrapper').text(oneTimeTotal);
            console.log('Updated one-time main price to:', oneTimeTotal);
        }
        
        if ($('.one-cut-price-wrapper').length) {
            if (compareTotal && compareTotal !== '$0.00' && compareTotal !== oneTimeTotal) {
                $('.one-cut-price-wrapper').text(compareTotal);
                console.log('Updated one-time compare price to:', compareTotal);
            } else {
                $('.one-cut-price-wrapper').text('');
                console.log('Cleared one-time compare price');
            }
        }
        
        // Update SUBSCRIBE section
        if ($('.sub-main-price-wrapper').length) {
            $('.sub-main-price-wrapper').text(subTotal);
            console.log('Updated subscribe main price to:', subTotal);
        }
        
        if ($('.sub-cut-price-wrapper').length) {
            if (subCompareTotal && subCompareTotal !== '$0.00' && subCompareTotal !== subTotal) {
                $('.sub-cut-price-wrapper').text(subCompareTotal);
                console.log('Updated subscribe compare price to:', subCompareTotal);
            } else {
                $('.sub-cut-price-wrapper').text('');
                console.log('Cleared subscribe compare price');
            }
        }
        
        // Update button price
        updateButtonPrice(isSubscribe ? subTotal : oneTimeTotal, 
                         isSubscribe ? subCompareTotal : compareTotal);
        
        // Update quantity
        updateQuantity(selectedQty);
        
        // Update bottle text
        updateBottleText();

        // UPDATE SHIPPING TEXT
        updateShippingText();
        
        // Toggle underwear display
        toggleFreeUnderwear();
        
        // Update size button and wrapper state
        updateSizeButtonAndWrapper();
    }
    
    function updateButtonPrice(mainPrice, cutPrice) {
        const buttonSpan = $('span.sticky-price');
        buttonSpan.html('');
        
        if (cutPrice && cutPrice !== '' && cutPrice !== mainPrice) {
            buttonSpan.html(`
                <span class="one-time-cut cut-price">${cutPrice}</span>
                ${mainPrice}
            `);
        } else {
            buttonSpan.text(mainPrice);
        }
    }
    
    // ---------------------------
    // SIMPLE CART BUTTON UPDATE FUNCTION
    // ---------------------------
    function updateCartButtonSimple(mainPrice, comparePrice) {
        console.log('updateCartButtonSimple called:', { mainPrice, comparePrice });
        
        // Find the cart button by searching for "ADD TO CART" text
        let cartButton = null;
        
        $('button').each(function() {
            const buttonText = $(this).text().toUpperCase();
            if (buttonText.includes('ADD TO CART') || buttonText.includes('ADD TO BAG')) {
                cartButton = $(this);
                console.log('Found cart button:', cartButton[0]);
                return false; // break the loop
            }
        });
        
        if (cartButton && cartButton.length) {
            // Get the current button text
            let currentText = cartButton.text();
            console.log('Current button text:', currentText);
            
            // Remove everything after "ADD TO CART" including any prices
            let baseText = 'ADD TO CART';
            if (currentText.includes('-')) {
                baseText = currentText.split('-')[0].trim();
            }
            
            // Build new button text
            let newText = baseText;
            if (comparePrice && comparePrice !== '' && comparePrice !== '$0.00' && comparePrice !== mainPrice) {
                newText = `${baseText} - ${mainPrice} ${comparePrice}`;
            } else {
                newText = `${baseText} - ${mainPrice}`;
            }
            
            console.log('New button text:', newText);
            cartButton.text(newText);
            
            // Also update any .sticky-price elements
            $('.sticky-price').each(function() {
                if (comparePrice && comparePrice !== '' && comparePrice !== '$0.00' && comparePrice !== mainPrice) {
                    $(this).html(`${mainPrice} <span class="cut-price">${comparePrice}</span>`);
                } else {
                    $(this).text(mainPrice);
                }
            });
            
        } else {
            console.error('Could not find cart button');
        }
    }
    
    // ---------------------------
    // VARIANT HANDLING FUNCTIONS
    // ---------------------------
    function setVariant(jarValue, variantId) {
        console.log('Setting jar value:', jarValue, 'Expected variant ID:', variantId);
        currentVariantId = variantId;
        
        if (variantSelects) {
            const jarButtons = variantSelects.querySelectorAll('input[name="options[Jar]"]');
            let found = false;
            
            jarButtons.forEach(input => {
                if (input.value === jarValue.toString()) {
                    input.checked = true;
                    input.dispatchEvent(new Event("change", { bubbles: true }));
                    found = true;
                    console.log('Triggered jar button:', jarValue);
                }
            });
            
            const jarSelect = variantSelects.querySelector('select[name="options[Jar]"]');
            if (jarSelect) {
                if (jarSelect.value !== jarValue.toString()) {
                    jarSelect.value = jarValue.toString();
                    jarSelect.dispatchEvent(new Event("change", { bubbles: true }));
                    found = true;
                    console.log('Updated jar select to:', jarValue);
                }
            }
            
            if (!found) {
                const allVariantInputs = document.querySelectorAll('input[name="id"]');
                allVariantInputs.forEach((input, index) => {
                    input.value = variantId;
                    input.disabled = false;
                });
            }
        }
    }

    function syncAllSelectors(variantId) {
        const isInitialLoad = !document.body.classList.contains('variant-synced');
        
        if (isInitialLoad) {
            // Honour whichever tier the MARKUP marks as default, rather than hardcoding
            // one here. This used to look for #option2 specifically, which silently beat
            // the `checked` attribute in main-product.liquid and pinned the page to the
            // 2-pouch tier no matter what the template said.
            const defaultRadio = document.querySelector('input[name="quantity_radio_group"][checked]');
            if (defaultRadio) {
                console.log('Preserving initial tier from markup:', defaultRadio.value);
                variantId = defaultRadio.dataset.variantId;
            }
            document.body.classList.add('variant-synced');
        }
        
        topJarButtons.forEach(btn => {
            btn.classList.toggle("active", btn.dataset.variantId == variantId);
        });

        // Two tiers can share one variant (the 6-pouch tile is the 3 Jar
        // variant at qty 6), so blanket-checking every matching radio used to
        // hand the selection to the LAST match — picking 6 instantly snapped
        // back to 3. If the checked radio already carries this variant, the
        // user's tier choice stands; only re-sync when the variant really
        // changed, and then to the first match only.
        const checkedRadio = document.querySelector('input[name="quantity_radio_group"]:checked');
        if (!checkedRadio || checkedRadio.dataset.variantId != variantId) {
            for (let i = 0; i < jarRadios.length; i++) {
                if (jarRadios[i].dataset.variantId == variantId) {
                    jarRadios[i].checked = true;
                    break;
                }
            }
        }
    }

    function initializeDefaultVariant() {
        // Take the default from the markup (the radio carrying `checked`), falling back
        // to whichever jar button the template marked active. Hardcoding a tier here is
        // what made the template's own default unreachable.
        const defaultRadio = document.querySelector('input[name="quantity_radio_group"][checked]');
        const defaultBtn = (defaultRadio && document.querySelector(`.jar-selector-btn[data-variant-id="${defaultRadio.dataset.variantId}"]`))
            || document.querySelector('.jar-selector-btn.active');

        if (defaultBtn) {
            const variantId = defaultBtn.dataset.variantId;
            const jarValue = defaultBtn.dataset.jarValue;

            console.log('Initializing default variant:', variantId, 'for jar:', jarValue);

            setVariant(jarValue, variantId);
            syncAllSelectors(variantId);
        }
    }
    
    // ---------------------------
    // EVENT HANDLERS
    // ---------------------------
    $(document).on('change', 'input[name="quantity_radio_group"]', function() {
        console.log('=== RADIO CHANGED - Cleaning up inline styles if needed ===');
        
        const variantId = $(this).data('variant-id') || $(this).attr('data-variant-id');
        const jarButton = $(`.jar-selector-btn[data-variant-id="${variantId}"]`);
        
        if (jarButton.length) {
            const variantAvailable = jarButton.data('variant-available') || jarButton.attr('data-variant-available');
            
            // If variant is available, clean up any inline styles
            if (variantAvailable !== 'false' && variantAvailable !== false) {
                cleanupInlineStyles();
            }
        }
        
        // Call the update function first
        updateSizeButtonAndWrapper();
        
        const jarValue = this.value;
        const variantId2 = this.dataset.variantId;
        
        setVariant(jarValue, variantId2);
        syncAllSelectors(variantId2);
        updateSellingPlan();
        updateAllPrices();
    });
    
    $(document).on('change', 'input[name="first_radio_group"]', function() {
        console.log('=== PURCHASE TYPE CHANGED ===');
        console.log('New value:', $(this).attr('id'));
        updateSizeButtonAndWrapper();
        updateSellingPlan();
        updateAllPrices();
    });
    
    $(document).on('change', 'input[name="underwear_size"]', function() {
        if (!isFreeProductEnabled()) {
            clearUnderwearProperty();
            return;
        }

        enableUnderwearProperty();
        $('input[name="properties[Period Underwear Size]"], .underwear-size-input').val(this.value);
    });
    
    // Size chart button
    $(document).on('click', '.size-view-btn', function() {
        $(".size-chart-popup").fadeIn();
    });
    
    // Close popup
    $(document).on('click', '.close-popup, .size-chart-popup', function(event) {
        if ($(event.target).hasClass("size-chart-popup") || 
            $(event.target).hasClass("close-popup") || 
            $(event.target).closest('.close-popup').length) {
            $(".size-chart-popup").fadeOut();
        }
    });
    
    // Size button toggle - ONLY IF VARIANT IS AVAILABLE
    $(document).on('click', '.size-button', function() {
        console.log('=== SIZE BUTTON CLICKED ===');
        
        // Check if button is disabled
        if ($(this).prop('disabled')) {
            console.log('Button is disabled - cannot toggle');
            return;
        }
        
        // Get current selected variant to check availability
        const selectedRadio = $('input[name="quantity_radio_group"]:checked');
        if (!selectedRadio.length) {
            console.log('No variant selected');
            return;
        }
        
        const variantId = selectedRadio.data('variant-id') || selectedRadio.attr('data-variant-id');
        const jarButton = $(`.jar-selector-btn[data-variant-id="${variantId}"]`);
        
        if (jarButton.length) {
            const variantAvailable = jarButton.data('variant-available') || jarButton.attr('data-variant-available');
            
            // Double-check availability before toggling
            if (variantAvailable === 'false' || variantAvailable === false) {
                console.log('Variant is unavailable - cannot toggle');
                return;
            }
        }
        
        const freeProductWrapper = $('.free-product-wrapper');
        
        // Clean up any inline styles first
        cleanupInlineStyles();
        
        // Log before toggle
        console.log('Before toggle:', {
            hasHiddenClass: freeProductWrapper.hasClass('hidden'),
            isVisible: freeProductWrapper.is(':visible'),
            inlineStyle: freeProductWrapper.attr('style'),
            classes: freeProductWrapper.attr('class')
        });
        
        // SIMPLY TOGGLE THE CLASS - NO MANUAL CSS
        freeProductWrapper.toggleClass('hidden');
        
        // Log after toggle
        console.log('After toggle:', {
            hasHiddenClass: freeProductWrapper.hasClass('hidden'),
            isVisible: freeProductWrapper.is(':visible'),
            inlineStyle: freeProductWrapper.attr('style'),
            classes: freeProductWrapper.attr('class')
        });
    });
    
    // Scroll buttons
    $(document).on('click', '.scroll-btn', function(event) {
        event.preventDefault();
        $("html, body").animate({
            scrollTop: $(".product__media-wrapper").offset().top,
        }, 800);
    });
    
    // Scroll to reviews
    $(document).on('click', '.point-review', function() {
        $("html, body").animate({
            scrollTop: $(".jdgm-rev-widg__header").offset().top
        }, 800);
    });
    
    // Click handling for TOP JAR BUTTONS
    topJarButtons.forEach(btn => {
        btn.addEventListener("click", function() {
            console.log('=== JAR BUTTON CLICKED ===');
            
            // Call the update function first
            updateSizeButtonAndWrapper();
            
            const jarValue = this.dataset.jarValue;
            const variantId = this.dataset.variantId;
            setVariant(jarValue, variantId);
            syncAllSelectors(variantId);
            updateSellingPlan();
            updateAllPrices();
        });
    });
    
    // Re-initialize after cart drawer operations
    $(document).on('cart-drawer:updated', function() {
        console.log('Cart drawer updated, re-checking subscription state');
        setTimeout(() => {
            initializeSellingPlanOnPageLoad();
            updateSizeButtonAndWrapper();
            cleanupInlineStyles();
        }, 100);
    });
    
    // Listen for cart drawer upgrade completion
    window.addEventListener('cartDrawerUpgradeComplete', function() {
        console.log('Cart drawer upgrade completed, re-checking subscription state');
        setTimeout(() => {
            initializeSellingPlanOnPageLoad();
            updateSizeButtonAndWrapper();
            cleanupInlineStyles();
        }, 200);
    });
    
    // ---------------------------
    // INITIALIZATION SEQUENCE
    // ---------------------------
    function initializeAll() {
        console.log('=== INITIALIZING ALL COMPONENTS ===');
        
        // 1. Initialize variant selection
        initializeDefaultVariant();
        
        // 2. Initialize selling plan FIRST (CRITICAL)
        initializeSellingPlanOnPageLoad();
        
        // 3. Setup form submission handler
        setupFormSubmissionHandler();
        if (!isFreeProductEnabled()) {
        clearUnderwearProperty();
    }
        // 4. Clean up any inline styles that might exist
        cleanupInlineStyles();
        
        // 5. Update all prices - CRITICAL: This needs to happen after everything is set
        setTimeout(() => {
            updateAllPrices(); // This calls updateSizeButtonAndWrapper()
            updateShippingText();
        }, 100);
        
        console.log('=== INITIALIZATION COMPLETE ===');
        console.log('Current selling plan value:', $('input[name="selling_plan"]').val());
        console.log('Current variant ID:', currentVariantId);
        console.log('Current quantity:', currentQuantity);
        console.log('Current purchase type:', $('#subscribe-save').is(':checked') ? 'Subscribe' : 'One Time');
    }
    
    // Run initialization with delay to ensure DOM is ready
    setTimeout(initializeAll, 500);
    
    // Re-initialize if page changes (for AJAX navigation)
    $(document).on('shopify:section:load', function() {
        setTimeout(initializeAll, 300);
    });
    
    // Handle URL hash
    if (window.location.hash === '#product-media-wrapper') {
        setTimeout(function() {
            $('html, body').animate({
                scrollTop: $('#product-media-wrapper').offset().top
            }, 1000);
        }, 1000);
    }
});